import { AlertMessage, MUIIcon, Spinner } from "../../../../widgets"
import { FC, useState } from "react"

import { IPaymentButtonProps } from "../IPaymentButtonProps"
import { PageLinkHelper } from "../../../../base/helpers"
import { PayTmScript } from "./PayTmScript"
import clsx from "clsx"
import { getButtonClass } from "../../buttons/helper"
import { toAbsoluteUrl } from "../../../../../helpers"
import { useAuth } from "../../../../../modules/auth"
import { useGetPaytmTokenMutation } from "./services"

export const PayTmButton: FC<IPaymentButtonProps> = ({
    entity, entityId,
    enrolmentNo,
    orderNo, amount,
    successPage, failedPage,
    disabled, icon, label, tooltip, style, size, className,
    children
}) => {
    const [isSubmitting, setIsSubmitting] = useState<boolean>(false)
    const [error, setError] = useState<string>()
    const [getToken] = useGetPaytmTokenMutation()
    const { siteId } = useAuth()

    const handleOnClick = () => {
        if (!siteId || !orderNo || !enrolmentNo ||!amount || !successPage || !failedPage)
            return;

        setError('')

        const successPageUrl = PageLinkHelper.getPageLinkUrl(siteId, successPage);
        const failedPageUrl = PageLinkHelper.getPageLinkUrl(siteId, failedPage);

        setIsSubmitting(true)
        getToken({
            amount,
            orderNo,
            entity,
            entityId,
            currency: "INR",
            enrolmentNo,
            successPageUrl,
            failedPageUrl
        })
            .unwrap()
            .then(result => {
                return PayTmScript.invokePaymentPage({
                    scriptInfo: { host: result.host, mid: result.mid },
                    data: {
                        amount: String(amount),
                        orderId: result.transactionId,
                        token: result.token,
                        tokenType: "TXN_TOKEN"
                    }
                })
            })
            .catch(err => {
                console.log(err)
            })
            .finally(() => {
                setIsSubmitting(false)
            })
    }

    return (
        <>
            <button
                disabled={disabled === true || isSubmitting === true || !orderNo || !amount}
                type="button"
                title={tooltip}
                onClick={handleOnClick}
                className={clsx(className, getButtonClass(style, size, "btn-secondary"))}
            >
                <Spinner show={isSubmitting} className="me-1" />
                <img
                    alt='img'
                    className='h-25px'
                    src={toAbsoluteUrl('/media/logos/paytm.png')}
                />
                {label && <label>{label}</label>}

                {(!isSubmitting && icon) && <MUIIcon iconName={icon} />}
                {children}
            </button>
            <AlertMessage type="Error" show={!!error} message={error} />
        </>
    )

} 